// ═══════════════════════════════════════════════════════════════
// API: Provisiones Laborales
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const provisionsAPI = {
  // Tipos de provisión activos de la empresa
  getTypes: (companyId) =>
    api.get(`/provisions/types/${companyId}`).then(r => r.data),

  // Balance + histórico de un empleado
  getByEmployee: (employeeId, companyId) =>
    api.get(`/provisions/employee/${employeeId}`, { params: { companyId } }).then(r => r.data),

  // Detalle y resumen de una nómina
  getByPayroll: (payrollId) =>
    api.get(`/provisions/payroll/${payrollId}`).then(r => r.data),

  // Dashboard general de la empresa
  getSummary: (companyId) =>
    api.get(`/provisions/summary/${companyId}`).then(r => r.data),

  // Liquidar provisiones (al pagar prestaciones)
  liquidate: (data) =>
    api.post('/provisions/liquidate', data).then(r => r.data),

  // Recalcular provisiones de una nómina
  recalculate: (payrollId, companyId) =>
    api.post(`/provisions/recalculate/${payrollId}`, { companyId }).then(r => r.data),

  // Recalcular TODAS las nóminas históricas (orden cronológico)
  recalculateAll: (companyId) =>
    api.post(`/provisions/recalculate-all/${companyId}`).then(r => r.data),
};
